import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Button2 from '@material-ui/core/Button';
import Avatar from 'components/Avatar';
import apiFetch from 'utils/apiFetch';
import { STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';
import {
  TAB_CHAT, TAB_COLLABORATE, TAB_TOOLS, TAB_USERS,
} from 'constants/others';
import { ROUTE_THINK } from 'constants/urls';
import ChatRoom from 'components/ChatRoom';
import AddUsers from 'components/AddUsers';
import FeedbackModal from 'components/FeedbackModal';
import GeneralModal from 'components/GeneralModal';
import ShareModal from 'components/ShareModal';
import NoToolsImg from 'assets/images/think/no_tools.svg';
import { CreationForm as ToolForm, ToolRow } from 'components/Tools';
import { TABLET_WIDTH } from 'constants/breakPoints';
import {
  ThinkTankSection, ThinkTankContent, ThinkTankTabs, ThinkTankTab, TabContent,
  ThinkTankHeader, BackArrow, Title, Buttons, TabContentMargin, DocIframe, BtnAddUsers,
  DesktopVersion, DesktopChat, DesktopTabs, InfoSection, BtnShare, NoPermission, NoPermissionImg,
  NoPermissionTitle, ButtonNextWrapper, Button, NoPermissionSubtitle, RequestButtons, RequestButtonAccept,
  RequestButtonReject, NoPermissionDesc,
} from './styles';

class ThinkTank extends Component {
  constructor(props) {
    super(props);

    const { match: { params: { id } } } = props;

    this.state = {
      id,
      tabSelected: TAB_COLLABORATE,
      toolsView: 'list',
      toolEdit: 0,
      recommendedUsers: [],
      inviteLoading: false,
      showModalInviteFeedback: false,
      windowWidth: window.innerWidth,
      showInfoThinkTank: false,
      showModalShare: false,
      thinkTankUrl: window.location.href,
      showGetOutThinkTank: false,
    };
  }

  componentDidMount() {
    const { getThinkTank } = this.props;
    const { id } = this.state;

    getThinkTank(id);

    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate({ actualThinkTankStatus: prevThinkTankStatus, match: prevMatch }) {
    const {
      actualThinkTankStatus, actualThinkTank, getThinkTankTools, match, getThinkTank,
    } = this.props;
    const { id } = this.state;
    if (prevThinkTankStatus !== actualThinkTankStatus && actualThinkTankStatus === STATUS_SUCCESS && actualThinkTank.permissions) {
      getThinkTankTools(id);
      this.getUserRecommendations();
    }
    if (prevMatch.params.id !== match.params.id) {
      this.setState({ id: match.params.id });
      getThinkTank(match.params.id);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    const { tabSelected } = this.state;
    this.setState({ windowWidth: window.innerWidth });

    if (window.innerWidth > TABLET_WIDTH && tabSelected === TAB_CHAT) {
      this.setState({ tabSelected: TAB_COLLABORATE });
    }
  }

  getUserRecommendations = () => {
    apiFetch('GET', { endPoint: 'think-seed/users/recommendations' }, {})
      .then((recommendedUsers) => {
        this.setState({ recommendedUsers });
      })
      .catch(() => {
        this.setState({ recommendedUsers: [] });
      });
  }

  backToThink = () => {
    const { history, resetSelectedChat } = this.props;
    resetSelectedChat();
    history.push(ROUTE_THINK);
  }

  handleClickTabChat = () => {
    this.setState({ tabSelected: TAB_CHAT });
  }

  handleClickTabCollaborate = () => {
    this.setState({ tabSelected: TAB_COLLABORATE });
  }

  handleClickTabTools = () => {
    this.setState({ tabSelected: TAB_TOOLS });
  }

  handleShowAddUsers = () => {
    this.setState({ tabSelected: TAB_USERS });
  }

  handleModalShare = () => {
    this.setState({ showModalShare: true });
  }

  handleCloseModalShare = () => {
    this.setState({ showModalShare: false });
  }

  handleClickCreateTool = () => {
    this.setState({ toolsView: 'creation', toolEdit: 0 });
  }

  handleCancelCreationTool = () => {
    this.setState({ toolsView: 'list' });
  }

  handleShowInfoThinkTank = () => {
    this.setState({ showInfoThinkTank: true });
  }

  handleCloseInfoThinkTank = () => {
    this.setState({ showInfoThinkTank: false });
  }

  handleGetOutThinkTank = () => {
    this.setState({ showGetOutThinkTank: true });
  }

  handleCloseGetOutThinkTank = () => {
    this.setState({ showGetOutThinkTank: false });
  }

  handleRefreshTools = () => {
    const { getThinkTankTools } = this.props;
    const { id } = this.state;

    getThinkTankTools(id);

    this.setState({ toolsView: 'list' });
  }

  handleEditTool = (toolId) => {
    this.setState({ toolsView: 'creation', toolEdit: toolId });
  }

  handleInvite = (selectedUsers) => {
    const { actualThinkTank } = this.props;

    this.setState({ inviteLoading: true });

    const usersIds = _.map(selectedUsers, user => user.id);

    apiFetch('POST', { endPoint: `think-tank/${actualThinkTank.id}/invite` }, { users_ids: usersIds.join(',') })
      .then(() => {
        this.setState({ inviteLoading: false, showModalInviteFeedback: true });
      })
      .catch(() => {
        this.setState({ inviteLoading: false });
      });
  }

  handleCloseModalInviteFeedback = () => {
    this.setState({ showModalInviteFeedback: false });

    this.handleClickTabCollaborate();
  }

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    const { name } = file;

    const reader = new FileReader();
    reader.onloadend = () => {
      this.uploadImage(reader.result, name);
    };
    reader.readAsDataURL(file);
  }

  handleRequestJoin = () => {
    const { requestJoin, requestThinkTankStatus } = this.props;
    const { id } = this.state;

    if (requestThinkTankStatus === STATUS_SUCCESS || requestThinkTankStatus === STATUS_FAILURE) {
      return false;
    }

    requestJoin(id);
    return true;
  }

  uploadImage = (data, name) => {
    const { changeThinkTankImage, actualThinkTank } = this.props;
    const params = {
      data,
      name,
    };

    apiFetch('POST', { endPoint: 'upload-file' }, params)
      .then((response) => {
        changeThinkTankImage(actualThinkTank.id, response.url);
      })
      .catch(() => {});
  }

  getOutThinkTank = () => {
    const { actualThinkTank, leaveThinkTank, history } = this.props;

    leaveThinkTank(actualThinkTank.id);

    this.handleCloseGetOutThinkTank();

    history.push(ROUTE_THINK);
  }

  printTabContent = () => {
    const { windowWidth } = this.state;
    if (windowWidth > TABLET_WIDTH) {
      return (
        <React.Fragment>
          {this.printCollaborate()}
          {this.printTools()}
          {this.printUsersInvitation()}
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        {this.printChat()}
        {this.printCollaborate()}
        {this.printTools()}
        {this.printUsersInvitation()}
      </React.Fragment>
    );
  }

  printChat = () => {
    const { tabSelected, windowWidth } = this.state;
    const { actualThinkTank } = this.props;

    const visible = tabSelected === TAB_CHAT || windowWidth > TABLET_WIDTH;

    if (!actualThinkTank.chat_id) {
      return null;
    }

    return (
      <div className={!visible ? 'hidden' : ''}>
        <ChatRoom key={actualThinkTank.chat_id} chatId={actualThinkTank.chat_id} />
      </div>
    );
  }

  printCollaborate = () => {
    const { actualThinkTank } = this.props;
    const { tabSelected } = this.state;

    if (!actualThinkTank.doc_url) {
      return null;
    }

    const url = `${actualThinkTank.doc_url}&overridemobile=true&fd=true&rm=minimal&headers=false`;
    return (<DocIframe width='100%' className={tabSelected !== TAB_COLLABORATE ? 'hidden' : ''} scrolling='yes' src={url} />);
  }

  printTools = () => {
    const {
      actualThinkTankTools, actualThinkTankToolsStatus, literals, actualThinkTank,
    } = this.props;
    const { toolsView, toolEdit, tabSelected } = this.state;

    if (toolsView === 'creation') {
      const tool = toolEdit ? _.find(actualThinkTankTools, { id: toolEdit }) : null;
      return (
        <TabContentMargin className={tabSelected !== TAB_TOOLS ? 'hidden' : ''}>
          <ToolForm
            elementType='think_tank'
            elementId={actualThinkTank.id}
            onSave={this.handleRefreshTools}
            tool={tool}
            onCancel={this.handleCancelCreationTool}
          />
        </TabContentMargin>
      );
    }

    if (actualThinkTankToolsStatus !== STATUS_SUCCESS) {
      return null;
    }

    let content = null;
    if (!actualThinkTankTools.length) {
      content = (
        <div className='no_elements'>
          <img alt='' src={NoToolsImg} />
          <div>{literals.noToolsMsg}</div>
        </div>
      );
    } else {
      const rows = _.map(actualThinkTankTools, tool => (
        <ToolRow tool={tool} key={tool.id} onDelete={this.handleRefreshTools} onEdit={this.handleEditTool} />
      ));

      content = (<TabContentMargin>{rows}</TabContentMargin>);
    }

    return (
      <div className={tabSelected !== TAB_TOOLS ? 'hidden' : ''}>
        {content}
        <Buttons>
          <button className='primary' onClick={this.handleClickCreateTool}>{literals.createTool}</button>
        </Buttons>
      </div>
    );
  }

  printUsersInvitation = () => {
    const {
      tabSelected, recommendedUsers, inviteLoading, showModalInviteFeedback,
    } = this.state;

    const { literals } = this.props;

    if (tabSelected !== TAB_USERS) {
      return null;
    }

    return (
      <div className='invite_users_tab_content'>
        <AddUsers
          recommendedUsers={recommendedUsers}
          onInvite={this.handleInvite}
          onCancel={this.handleClickTabCollaborate}
          isLoading={inviteLoading}
        />
        <FeedbackModal
          open={showModalInviteFeedback}
          success
          onClose={this.handleCloseModalInviteFeedback}
          text={literals.invitationsSent}
        />
      </div>
    );
  }

  printContent = () => {
    const {
      actualThinkTank, actualThinkTankStatus, literals, app: { color1 },
    } = this.props;
    const { tabSelected, windowWidth } = this.state;

    if (actualThinkTankStatus !== STATUS_SUCCESS) {
      return null;
    }

    if (!actualThinkTank.id) {
      return null;
    }

    if (windowWidth > TABLET_WIDTH) {
      return this.printDesktopVersion();
    }

    return (
      <ThinkTankContent>
        <ThinkTankTabs>
          <ThinkTankTab color={color1} active={tabSelected === TAB_COLLABORATE} onClick={this.handleClickTabCollaborate}>
            {literals.collaborate}
          </ThinkTankTab>
          <ThinkTankTab color={color1} active={tabSelected === TAB_CHAT} onClick={this.handleClickTabChat}>
            {literals.chat}
          </ThinkTankTab>
          <ThinkTankTab color={color1} active={tabSelected === TAB_TOOLS} onClick={this.handleClickTabTools}>
            {literals.tools}
          </ThinkTankTab>
        </ThinkTankTabs>
        <TabContent color={color1}>
          {this.printTabContent()}
        </TabContent>
      </ThinkTankContent>
    );
  }

  printGetOutThinkTank = () => {
    const { showGetOutThinkTank } = this.state;
    const { literals } = this.props;
    const type = 'select';

    return (
      <GeneralModal
        open={showGetOutThinkTank}
        onClose={this.handleCloseGetOutThinkTank}
        onAccept={this.getOutThinkTank}
        type={type}
        text={literals.getOut}
      />

    );
  }

  printShareModal = () => {
    const { showModalShare, thinkTankUrl } = this.state;

    if (thinkTankUrl) {
      return (
        <ShareModal
          open={showModalShare}
          docUrl={thinkTankUrl}
          onClose={this.handleCloseModalShare}
        />
      );
    }
    return <React.Fragment />;
  }

  printDesktopVersion = () => {
    const { tabSelected: originalTabSelected } = this.state;
    const {
      literals, app: { color1 },
    } = this.props;

    const tabSelected = originalTabSelected === TAB_CHAT ? TAB_COLLABORATE : originalTabSelected;

    return (
      <DesktopVersion>
        <DesktopTabs>
          <ThinkTankContent>
            <ThinkTankTabs>
              <ThinkTankTab color={color1} active={tabSelected === TAB_COLLABORATE} onClick={this.handleClickTabCollaborate}>
                {literals.collaborate}
              </ThinkTankTab>
              <ThinkTankTab color={color1} active={tabSelected === TAB_TOOLS} onClick={this.handleClickTabTools}>
                {literals.tools}
              </ThinkTankTab>
            </ThinkTankTabs>
            <TabContent className='tab_content' color={color1}>
              {this.printTabContent()}
            </TabContent>
          </ThinkTankContent>
        </DesktopTabs>
        <DesktopChat>
          {this.printChat()}
        </DesktopChat>
      </DesktopVersion>
    );
  }

  printUsersInHeader = () => {
    const { actualThinkTank, user, literals } = this.props;

    if (!actualThinkTank) {
      return null;
    }

    const members = [...actualThinkTank.members];

    members.sort((a, b) => {
      if (a.id === user.id) {
        return 1;
      }

      if (b.id === user.id) {
        return -1;
      }

      let aName = `${a.firstname} ${a.lastname}`;
      aName = aName.toLowerCase();

      let bName = `${b.firstname} ${b.lastname}`;
      bName = bName.toLowerCase();

      return aName < bName ? -1 : 1;
    });

    let text = '';

    _.forEach(members, (member, i) => {
      if (i > 0) {
        if (i === (members.length - 1)) {
          text += ` ${literals.and} `;
        } else {
          text += ', ';
        }
      }

      if (member.id === user.id) {
        text += literals.you;
      } else {
        text += `${member.firstname} ${member.lastname}`;
      }
    });

    return text;
  }

  printHeader = () => {
    const { actualThinkTank, actualThinkTankStatus } = this.props;

    if (actualThinkTankStatus !== STATUS_SUCCESS) {
      return null;
    }

    if (!actualThinkTank.id) {
      return null;
    }

    const image = actualThinkTank.image;
    const name = actualThinkTank.name;

    return (
      <ThinkTankHeader>
        <BackArrow onClick={this.backToThink}>
          <i className='fa fa-arrow-left' />
        </BackArrow>
        <Title onClick={this.handleShowInfoThinkTank}>
          <div className='avatar_image'>
            <Avatar size={32} avatar={image} firstname={name} />
          </div>
          <div className='header_text'>
            <div className='name_think_tank'>
              <p>
                {decodeURIComponent(actualThinkTank.name)}
              </p>
            </div>
            <div className='users_list'>
              {this.printUsersInHeader()}
            </div>
          </div>
        </Title>
        <BtnAddUsers onClick={this.handleShowAddUsers}>
          <i className='fas fa-user-plus' />
        </BtnAddUsers>
        <BtnShare onClick={this.handleModalShare}>
          <i className='fas fa-share-alt-square' />
        </BtnShare>
      </ThinkTankHeader>
    );
  }

  printInfoView = () => {
    const { actualThinkTank, literals } = this.props;

    const usersRows = _.map(actualThinkTank.members, user => (
      <ListItem alignItems='flex-center'>
        <ListItemAvatar>
          <Avatar firstname={user.firstname} size={42} avatar={user.avatar} />
        </ListItemAvatar>
        <ListItemText
          className='user-list__item--text'
          primary={`${user.firstname} ${user.lastname}`}
        />
      </ListItem>
    ));

    const { image } = actualThinkTank;

    return (
      <InfoSection image={image}>
        <div className='header'>
          <div className='opacity-frame' />
          <div className='arrow_layer' onClick={this.handleCloseInfoThinkTank}>
            <i className='fa fa-arrow-left' />
          </div>
          <input
            type='file'
            id='document_file'
            name='document_file'
            style={{ display: 'none' }}
            onChange={this.handleFileUpload}
            accept='image/png, image/jpeg'
          />
          <label className='edit_image_layer' htmlFor='document_file'>
            <i className='fas fa-edit' />
          </label>
          <div className='title_layer'>
            <div className='title_content'>{decodeURIComponent(actualThinkTank.name)}</div>
          </div>
        </div>
        <div className='title_header'>
          {literals.info}
        </div>
        <div className='description_layer'>
          <div className='description_title'>{literals.description}</div>
          <div className='description_content'>{decodeURIComponent(actualThinkTank.description)}</div>
        </div>
        <div className='members'>
          <div className='members_title'>{literals.members}</div>
          {usersRows}
        </div>
        <div>
          {this.printRequestsJoin()}
          {this.printGetOutThinkTank()}
        </div>
        <div className='deleteButton'>
          <Button2 className='danger' onClick={this.handleGetOutThinkTank}>
            <i className='fas fa-trash-alt' style={{ marginRight: '10px' }} />
            {literals.delete}
          </Button2>
        </div>
      </InfoSection>
    );
  }

  printNoPermissionsView = () => {
    const {
      literals, actualThinkTank, requestThinkTankStatus, requestThinkTankError,
    } = this.props;
    const { name, image, description } = actualThinkTank;
    return (
      <NoPermission>
        <NoPermissionTitle>{decodeURIComponent(name)}</NoPermissionTitle>
        <NoPermissionSubtitle>{decodeURIComponent(description)}</NoPermissionSubtitle>
        <NoPermissionImg src={image} size={120} />
        <NoPermissionDesc>{literals.noPermissions}</NoPermissionDesc>
        <ButtonNextWrapper>
          <Button onClick={this.handleRequestJoin}>
            {requestThinkTankStatus === STATUS_SUCCESS ? literals.sentRequest : literals.requestPermission}
          </Button>
        </ButtonNextWrapper>
        {requestThinkTankStatus === STATUS_FAILURE ? (<div className='error_msg'>{requestThinkTankError.error}</div>) : null}
      </NoPermission>
    );
  }

  handleResponseRequest = (event) => {
    const requestId = parseInt(event.currentTarget.getAttribute('data-id'), 10);
    const type = parseInt(event.currentTarget.getAttribute('data-type'), 10);
    const { id } = this.state;
    const { acceptJoin, rejectJoin } = this.props;
    if (type === 0) {
      acceptJoin(id, requestId);
    } else {
      rejectJoin(id, requestId);
    }
  }

  printRequestsJoin = () => {
    const { requestsJoinThinkTank, literals } = this.props;

    const usersRows = _.map(requestsJoinThinkTank, request => (
      <ListItem alignItems='flex-center'>
        <ListItemAvatar>
          <Avatar firstname={request.user.firstname} size={42} avatar={request.user.avatar} />
        </ListItemAvatar>
        <ListItemText
          className='user-list__item--text'
          primary={`${request.user.firstname} ${request.user.lastname}`}
        />
        <RequestButtons>
          <button data-id={request.id} data-type='0' onClick={this.handleResponseRequest}>
            <RequestButtonAccept>
              <i className='fas fa-check' />
            </RequestButtonAccept>
          </button>
          <button data-id={request.id} data-type='1' onClick={this.handleResponseRequest}>
            <RequestButtonReject>
              <i className='fas fa-times' />
            </RequestButtonReject>
          </button>
        </RequestButtons>
      </ListItem>
    ));

    if (requestsJoinThinkTank.length > 0) {
      return (
        <div className='req_members'>
          <div className='members_title'>{literals.reqMembers}</div>
          {usersRows}
        </div>
      );
    }
    return (null);
  }

  render() {
    const { showInfoThinkTank } = this.state;
    const { actualThinkTank } = this.props;

    if (!actualThinkTank) {
      return null;
    }

    if (!actualThinkTank.permissions) {
      return this.printNoPermissionsView();
    }

    if (showInfoThinkTank) {
      return this.printInfoView();
    }
    return (
      <ThinkTankSection>
        {this.printHeader()}
        {this.printContent()}
        {this.printShareModal()}
      </ThinkTankSection>
    );
  }
}

ThinkTank.propTypes = {
  app: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getThinkTank: PropTypes.func.isRequired,
  actualThinkTank: PropTypes.object,
  actualThinkTankStatus: PropTypes.string,
  getThinkTankTools: PropTypes.func.isRequired,
  requestJoin: PropTypes.func.isRequired,
  acceptJoin: PropTypes.func.isRequired,
  rejectJoin: PropTypes.func.isRequired,
  requestsJoinThinkTank: PropTypes.array,
  actualThinkTankTools: PropTypes.object,
  actualThinkTankToolsStatus: PropTypes.string,
  changeThinkTankImage: PropTypes.func.isRequired,
  leaveThinkTank: PropTypes.func.isRequired,
};

ThinkTank.defaultProps = {
  actualThinkTank: null,
  actualThinkTankStatus: null,
  actualThinkTankTools: null,
  actualThinkTankToolsStatus: null,
  requestsJoinThinkTank: null,
};

export default ThinkTank;



// WEBPACK FOOTER //
// ./src/routes/ThinkTank/components/index.jsx